"use client"

import * as React from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import SuperTokensReact, { SuperTokensWrapper } from "supertokens-auth-react";
import { frontendConfig } from "../config/auth/supertokens/frontend/frontendConfigUtils";
import { Toaster } from "@workspace/ui/components/sonner";

let hasInitialisedSuperTokens = false;

function ensureSuperTokensInitialized() {
  if (typeof window === "undefined" || hasInitialisedSuperTokens) {
    return;
  }

  SuperTokensReact.init(frontendConfig());
  hasInitialisedSuperTokens = true;
}

export function Providers({ children }: { children: React.ReactNode }) {
  ensureSuperTokensInitialized();

  return (
    <SuperTokensWrapper>
      <NextThemesProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
        enableColorScheme
      >
        {children}
        <Toaster richColors position="top-right" />
      </NextThemesProvider>
    </SuperTokensWrapper>
  )
}
